/** @format */

import React from 'react';
import { Grid, Typography, Card, CardContent, CardMedia, CardActionArea } from '@mui/material';
import { useStyles } from './style';
import jMoment from 'moment-jalaali';
import useCustomHook from './hooks';
import createToast from 'components/Toast/Toast';
import { ButtonLoading, ConfirmDialog } from 'components';
import Services from '../../services';
import FileSaver from 'file-saver';
import { Icons } from 'components';

require('moment/locale/fa');

export default function DocItem({
  file,
  refreshList = () => {},
  disableDelete = false,
  docTypes = [],
  onDeleted = () => {},
  requestId = null,
  preferedName = null,
  isDocSrv = false,
  isRemovable = true,
  isEditPage = false,
}) {
  // -- STATES --//

  const {
    deleting,
    setDeleting,
    confirmDeleteModal,
    setConfirmDeleteModal,
    thumbnailIsLoaded,
    setThumbnailIsLoaded,
    isLoading,
    setIsLoading,
  } = useCustomHook();
  // --HOOKS--//
  const classes = useStyles();

  const downloadFile = async (data) => {
    if (isLoading) {
      return;
    }
    const hash = getHash();
    if (!hash) {
      createToast('خطا', 'خطایی در مشاهده سند رخ داده', 'danger');
      return;
    }
    setIsLoading(true);
    try {
      const res = await Services.getFile(hash);
      setIsLoading(false);
      let filename = res.headers['content-disposition'];
      if (filename) {
        filename = filename
          .split(';')
          .find((n) => n.includes('filename='))
          .replace('filename=', '')
          .trim();
        filename = JSON.parse(decodeURI(filename));
        const b = new Blob([res.data]);
        FileSaver.saveAs(b, filename);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const deleteFile = async () => {
    try {
      if (!requestId) {
        return await forceDeleteFile();
      }
      if (!file?.id) return;
      setDeleting(true);
      if (file.isNewFile) {
        const param = {
          fileHashes: [file.hash],
          folderHashes: [],
        };
        await Services.deleteDocService(param);
      } else {
        if (isRemovable) {
          await Services.putRequest(requestId, [file.id]);
        }
      }
      setDeleting(false);

      await onDeleted();
      refreshList();
    } catch (error) {
      setDeleting(false);
    }
  };

  const forceDeleteFile = async () => {
    try {
      refreshList();
      onDeleted();
    } catch (error) {
      createToast('خطا', 'خطایی در حذف سند رخ داده', 'danger');
    }
  };

  // --OTHER FUNCTIONS--//
  const handleRemoveAvatar = () => {
    deleteFile().then((_) => setConfirmDeleteModal(false));
  };

  const getThumbnail = () => {
    const hash = getHash();
    return `${process.env?.REACT_APP_BASE_URL_UPLOAD_PODSAPCE + hash}/thumbnail`;
  };

  const getHash = () => {
    if (!isDocSrv) return file?.hash;
    const url = file?.url ?? '';
    const splitted = url.split('/');
    if (splitted.length === 0) {
      createToast('خطا', 'آدرس فایل یافت نشد!', 'danger');

      return null;
    }
    const hash = splitted[splitted.length - 1];
    return hash && hash.length > 0 ? hash : null;
  };

  const getDocTypeText = (docType) => {
    return docTypes.find((doc) => doc.value === docType)?.label ?? null;
  };

  return (
    <Grid item xs={12} sm={6} lg={3}>
      <ConfirmDialog
        open={confirmDeleteModal}
        onClose={() => setConfirmDeleteModal(false)}
        onConfirm={handleRemoveAvatar}
        title="تایید حذف سند"
        content="آیا از حذف سند انتخاب شده اطمینان دارید؟"
        confirmButtonText="حذف سند"
        cancelButtonProps="انصراف"
        loading={deleting}
      />

      <Card elevation={0} variant="outlined" className={classes.root} container>
        <CardActionArea>
          <CardMedia>
            <Grid container justifyContent="center" alignItems="center" className={classes.fileFormatCard}>
              {isDocSrv ? (
                <img
                  src={getThumbnail()}
                  alt="پیش‌نمایش سند"
                  onLoad={() => setThumbnailIsLoaded(true)}
                  style={{ display: thumbnailIsLoaded ? 'block' : 'none' }}
                />
              ) : null}
              {!isDocSrv && file?.thumbnail === 1 ? (
                <img
                  src={getThumbnail()}
                  alt="پیش‌نمایش سند"
                  onLoad={() => setThumbnailIsLoaded(true)}
                  style={{ display: thumbnailIsLoaded ? 'block' : 'none' }}
                />
              ) : null}
              {file?.thumbnail === -1 || !thumbnailIsLoaded ? (
                <Typography variant="h3" component="div" style={{ direction: 'ltr' }}>
                  {file?.extension ? (
                    `.${file?.extension}`
                  ) : isDocSrv ? (
                    <Icons icon="Document" color="#2B3990" size="35" />
                  ) : (
                    ''
                  )}
                </Typography>
              ) : null}
            </Grid>
          </CardMedia>
        </CardActionArea>

        <CardContent className={classes.content}>
          <Typography className={classes.fileName} variant="h5" color="textPrimary" component="div">
            {preferedName ||
              (file?.documentType ? getDocTypeText(file?.documentType) ?? file?.name : file?.name)}
          </Typography>
          <Typography className={classes.date} color="textSecondary" component="div">
            {jMoment(file?.created).format('dddd, jD jMMMM jYYYY')}
          </Typography>
          <Grid container item className={classes.buttonGroup}>
            <ButtonLoading
              onClick={downloadFile}
              className={classes.viewButton}
              color="primary"
              variant="outlined"
              loading={isLoading}
              disabled={isLoading}
              name="مشاهده"
            />
            {isEditPage && (
            <ButtonLoading
              onClick={() => (!disableDelete ? setConfirmDeleteModal(true) : null)}
              className={classes.deleteButton}
              color="primary"
              variant="outlined"
              disabled={disableDelete || deleting}
              name={'حذف'}
            />
            )}
            
          </Grid>
        </CardContent>
      </Card>
    </Grid>
  );
}
